import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconPlus: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 7}
      height={height ?? 7}
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.6548 6.91052V5.24521e-06H4.25565V6.91052H2.6548ZM-3.32445e-05 4.25569V2.65483H6.91048V4.25569H-3.32445e-05Z"
        fill={color ?? "#050038"}
      />
    </svg>
  );
};
